import React, { useState } from 'react';
import { Card, Button, Typography, Space, Row, Col } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const { Text, Link } = Typography;

const EditWidgetCard = ({
  widgetTopic,
  header,
  description,
  widgetImage,
  ageGroup,
  onDelete,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const imageContainerStyle = {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px', // Adjust as needed
    overflow: 'hidden',
    cursor: 'pointer',
  };

  const widgetImageStyle = {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    transition: 'transform 0.3s ease',
    transform: isHovered ? 'scale(1.05)' : 'scale(1)',
  };

  const deleteButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    opacity: isHovered ? 1 : 0,
    transition: 'opacity 0.3s ease',
  };

  return (
    <Col xs={24} sm={12} md={8} lg={6}>
      <Card
        hoverable
        style={{ width: '100%' }}
        cover={
          <div
            style={imageContainerStyle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {widgetImage && (
              <img
                alt={widgetTopic}
                src={widgetImage}
                style={widgetImageStyle}
              />
            )}
            <Button
              type="primary"
              danger
              shape="circle"
              icon={<DeleteOutlined />}
              style={deleteButtonStyle}
              onClick={onDelete}
            />
          </div>
        }
      >
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <Text strong style={{ fontSize: '16px' }}>
            {widgetTopic}
          </Text>
          <Text type="secondary" style={{ fontSize: '14px' }}>
            {header}
          </Text>
          <Text type="secondary" style={{ fontSize: '14px' }}>
            {description}
          </Text>
          <Text type="secondary" style={{ fontSize: '14px' }}>
           {ageGroup}
          </Text>
        </Space>
      </Card>
    </Col>
  );
};

export default EditWidgetCard;
